import React, { useEffect, useState, useRef } from "react";
import { CompanyDto, getCompanies } from "../../../api/companies";
import { CompanyModal } from "../../Companies/CompanyModal";

import "../../../styles/warehouse/SupplierSelect.css";

interface Props {
  value: number | undefined;
  onChange: (id: number | undefined) => void;
}

export default function SupplierSelect({ value, onChange }: Props) {
  const [suppliers, setSuppliers] = useState<CompanyDto[]>([]);
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    load();
  }, []);

  async function load() {
    const companies = await getCompanies();
    setSuppliers(companies.filter((c) => c.roles.includes("supplier")));
  }

  const selected = suppliers.find((s) => s.id === value) || null;

  const filtered = suppliers.filter((s) =>
    s.name.toLowerCase().includes(search.toLowerCase())
  );

  // Закрытие при клике вне
  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <div className="supplier-select" ref={ref}>
      <input
        className="supplier-input"
        placeholder="Выберите поставщика..."
        value={selected ? selected.name : search}
        onFocus={() => setOpen(true)}
        onChange={(e) => {
          setSearch(e.target.value);
          onChange(undefined);
          setOpen(true);
        }}
      />

      {open && (
        <div className="supplier-dropdown">
          {filtered.map((s) => {
            const main = s.contacts?.find((c) => c.isMain);

            return (
              <div
                key={s.id}
                className={
                  "supplier-item" +
                  (value === s.id ? " supplier-item-selected" : "")
                }
                onClick={() => {
                  onChange(s.id);
                  setOpen(false);
                }}
              >
                <div className="supplier-item-name">{s.name}</div>
                {main && (
                  <div className="supplier-item-contact">
                    {main.name} — {main.phone}
                  </div>
                )}
              </div>
            );
          })}

          <div
            className="supplier-create"
            onClick={() => {
              setOpen(false);
              setModalOpen(true);
            }}
          >
            + Создать поставщика
          </div>
        </div>
      )}

      {modalOpen && (
        <CompanyModal
          company={{ id: undefined, roles: ["supplier"], contacts: [] } as any}
          onClose={() => {
            setModalOpen(false);
            load();
          }}
        />
      )}
    </div>
  );
}